import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import Global from "../../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import MainLoader from "../Loaders/MainLoader";
import { Link, useNavigate, useParams } from "react-router-dom";
import { map } from "leaflet";
import CopyToClipboard from "react-copy-to-clipboard";
import Papa from 'papaparse';

function Bulkshipmentimport()
{
    const navigate = useNavigate();
    const [file, setFile] = useState(null);
    const { headers1, headers2, logout } = AuthUser();
    const [Loading, setLoading] = useState(false);
    const [serviceName, setServiceName] = useState([]);

    useEffect(() => {
          GetServices();
        }, []);
        const GetServices=()=>{
          axios({
              method: 'post',
              url: Global.baseUrl+'Servicesname',
              headers:headers1,
              data: {}
            })
            .then(function (response) {
              if(response.data.status == 200)
              {
                  var data=response.data.value;
                  setServiceName(data);
              }
            })
            .catch(function (error) {
              if(error.response.status==401){
                  toast.error(error.response.statusText);
                  logout();
                  navigate('/');
                  window.location.reload();
              }
              // console.log(error);
          });
        }

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = 'example_shipment_upload.csv'; // Path to your file
        link.download = 'example_shipment_upload.csv'; // Name of the file to be downloaded
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

    //   const handleFileChange = (e) => {
    //     setFile(e.target.files[0]);
    //     handleUpload();
    //   };
   const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);

    Papa.parse(uploadedFile, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
            const data = results.data;
            const errors = [];

            // Helper functions
            const cleanValue = val =>
                typeof val === 'string'
                    ? val.trim().replace(/[^\x20-\x7E]/g, '') // remove invisible/unicode chars
                    : val;

            const isValidMobile = val => /^[0-9]{6,15}$/.test(val);
            const isValidEmail = val => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

            data.forEach((row, index) => {
                const rowNum = index + 2; // Adjust for header row

                // Clean all fields
                Object.keys(row).forEach(key => {
                    row[key] = cleanValue(row[key]);
                });

                // Start validation
                if (!row['Product Type'] || !['Document', 'Parcel'].includes(row['Product Type'])) {
                    errors.push(`Row ${rowNum}: Invalid Product Type. Only 'Document' or 'Parcel' allowed.`);
                }

                if (!row['Booking Type'] || !['0', '1'].includes(row['Booking Type'])) {
                    errors.push(`Row ${rowNum}: Invalid Booking Type. Only '0' or '1' allowed.`);
                }

                if (!row['Origin']) {
                    errors.push(`Row ${rowNum}: Origin is empty`);
                }

                if (!row['Destination']) {
                    errors.push(`Row ${rowNum}: Destination is empty`);
                }

                if (!row['Pieces'] || isNaN(row['Pieces'])) {
                    errors.push(`Row ${rowNum}: Pieces is invalid or empty (should be a number)`);
                }

                if (!row['Product Name']) {
                    errors.push(`Row ${rowNum}: Product Name is empty`);
                }

                if (!row['Weight'] || isNaN(row['Weight'])) {
                    errors.push(`Row ${rowNum}: Weight is invalid or empty`);
                }

                if (!row['Height'] || isNaN(row['Height'])) {
                    errors.push(`Row ${rowNum}: Height is invalid or empty`);
                }

                if (!row['Width'] || isNaN(row['Width'])) {
                    errors.push(`Row ${rowNum}: Width is invalid or empty`);
                }

                if (!row['Length'] || isNaN(row['Length'])) {
                    errors.push(`Row ${rowNum}: Length is invalid or empty`);
                }

                if (!row['Parcel Value'] || isNaN(row['Parcel Value'])) {
                    errors.push(`Row ${rowNum}: Parcel Value is invalid or empty`);
                }

                if (!row['Shipment Status'] || !['B'].includes(row['Shipment Status'])) {
                    errors.push(`Row ${rowNum}: Shipment Status is invalid (Only 'B' allowed)`);
                }

                if (!row['Receiver Name']) {
                    errors.push(`Row ${rowNum}: Receiver Name is empty`);
                }

                if (!row['Receiver Address']) {
                    errors.push(`Row ${rowNum}: Receiver Address is empty`);
                }

                if (!row['Receiver City'] || !isNaN(row['Receiver City'])) {
                    errors.push(`Row ${rowNum}: Receiver City is invalid (should be a string)`);
                }

                if (!row['Receiver State'] || !isNaN(row['Receiver State'])) {
                    errors.push(`Row ${rowNum}: Receiver State is invalid (should be a string)`);
                }

                if (!row['Receiver Country'] || !isNaN(row['Receiver Country'])) {
                    errors.push(`Row ${rowNum}: Receiver Country is invalid (should be a string)`);
                }

                if (!row['Receiver Zip']) {
                    errors.push(`Row ${rowNum}: Receiver Zip is empty`);
                }

                if (!isValidMobile(row['Receiver Mobile'])) {
                    errors.push(`Row ${rowNum}: Receiver Mobile is invalid (should be a valid number)`);
                }

                if (!isValidEmail(row['Receiver Email'])) {
                    errors.push(`Row ${rowNum}: Receiver Email is invalid`);
                }

                if (!row['Sender Name']) {
                    errors.push(`Row ${rowNum}: Sender Name is empty`);
                }

                if (!row['Sender Address']) {
                    errors.push(`Row ${rowNum}: Sender Address is empty`);
                }

                if (!row['Sender City'] || !isNaN(row['Sender City'])) {
                    errors.push(`Row ${rowNum}: Sender City is invalid (should be a string)`);
                }

                if (!row['Sender State'] || !isNaN(row['Sender State'])) {
                    errors.push(`Row ${rowNum}: Sender State is invalid (should be a string)`);
                }

                if (!row['Sender Country'] || !isNaN(row['Sender Country'])) {
                    errors.push(`Row ${rowNum}: Sender Country is invalid (should be a string)`);
                }

                if (!row['Sender Zip']) {
                    errors.push(`Row ${rowNum}: Sender Zip is empty`);
                }

                if (!isValidMobile(row['Sender Mobile'])) {
                    errors.push(`Row ${rowNum}: Sender Mobile is invalid (should be a valid number)`);
                }

                if (!isValidEmail(row['Sender Email'])) {
                    errors.push(`Row ${rowNum}: Sender Email is invalid`);
                }

                if (!row['Service Code']) {
                    errors.push(`Row ${rowNum}: Service Code is empty`);
                }

                if (!row['COD Amount'] || isNaN(row['COD Amount'])) {
                    errors.push(`Row ${rowNum}: COD Amount is invalid or empty`);
                }

                if (!row['COD Charge'] || !['Y', 'N'].includes(row['COD Charge'])) {
                    errors.push(`Row ${rowNum}: COD Charge is invalid (Only 'Y' or 'N' allowed)`);
                }

                if (!row['Insurance Charge'] || !['Y', 'N'].includes(row['Insurance Charge'])) {
                    errors.push(`Row ${rowNum}: Insurance Charge is invalid (Only 'Y' or 'N' allowed)`);
                }

                if (!row['Custom Cleareance'] || !['Y', 'N'].includes(row['Custom Cleareance'])) {
                    errors.push(`Row ${rowNum}: Custom Cleareance is invalid (Only 'Y' or 'N' allowed)`);
                }
            });

            if (errors.length > 0) {
                toast.error(`Validation Failed:\n${errors.join('\n')}`, { autoClose: false });
                return;
            }

            // All good – upload
            handleUpload(uploadedFile);
        },
    });
};


      const handleUpload = (validatedFile) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('file', validatedFile);
        axios.post(Global.baseUrl + 'uploadShipment', formData, {
            headers: headers2,
          })
          .then((response) => {
            toast.success('File uploaded successfully');
            setLoading(false);
          })
          .catch((error) => {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            setLoading(false);
          });
      };
    return(
        <>
            <LeftPanel/>
            <main className='home-section'>
                <Header/>
                <ToastContainer />
                {Loading == true ? <MainLoader /> :
                    <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                            <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                <li className="breadcrumb-item">
                                    <a href="#">
                                    <i className="bx bx-home text-primary-400 fs-6"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">Shipments</li>
                            </ol>
                        </nav>
                        <div className="d-flex justify-content-between">
                            <div className="">
                                <button className="btn btn_nav btn-sm" onClick={() => navigate(-1)}>
                                <i className="bx bx-arrow-back "></i>
                                </button>
                            </div>
                            <div className="ps-2 ">
                                <h2 className="h4">Bulk Shipment Import</h2>
                            </div>
                        </div>
                    </div>
                
                    <div className="btn-toolbar mb-2 mb-md-0">
                        
                    </div>
                </div>

                <div className="mb-3">
                    <div className="alert alert-info" role="alert">
                        <h6>Notes:</h6>
                        <ul>
                            <li>While uploading bulk data, your credit limit or wallet balance will not be affected.</li>
                            <li>Default number of pic is only 1</li>
                            {/* <li>Not allow to add multiple shipment under one master AWB.</li> */}
                        </ul>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 col-md bulk_import fileinput">
                        <div className="card">
                        <div className="card-body">
                            <label className="custom-file-upload">
                                    <input type="file" onChange={handleFileChange} accept=".csv,.xlsx,.xls" />
                                <i className="fa fa-cloud-upload"></i> Browse and Upload
                            </label>
                            <p>Please download and use sample template file Only csv file format is acceptable</p>
                        </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-sm p-3">
                            <div className="card-body">
                            <h3><i className="fa fa-lightbulb-o" aria-hidden="true"></i></h3>
                            <ul>
                                <li>Download the sample file and replace its data with your order data.</li>
                                <li>Make sure all mandatory fields are filled. Save the file and upload it back.</li>
                            </ul>

                            <div className="d-grid">
                                <a onClick={handleDownload} target="_blank" className="btn btn-primary btn-block">Download Sample File</a>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="py-3">
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="card" >
                                <div className="card-body">
                                    <h5 className="card-title">Available Services (Domestic)</h5>
                                    <table className="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Service</th>
                                            <th>Service Code</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Parcel</td>
                                            <td>
                                                <ul type="none">
                                                {serviceName.map((ser, i) => {
                                                    return (
                                                    ser.booking_type === 'Domestic' && ser.product_type === 'Parcel' && (
                                                        <li key={i}>{ser.services_name}</li>
                                                    )
                                                    );
                                                })}
                                                </ul>
                                            </td>
                                            <td>
                                                <ul type="none">
                                                {serviceName.map((ser, i) => {
                                                    return (
                                                    ser.booking_type === 'Domestic' && ser.product_type === 'Parcel' && (
                                                        <li key={i}>{ser.unique_id} <CopyToClipboard text={ser.unique_id} onCopy={()=>{toast.success(ser.unique_id+' Copied To Clipboard')}}><i className="bx bx-copy"></i></CopyToClipboard></li>
                                                    )
                                                    );
                                                })}
                                                </ul>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Document</td>
                                            <td>
                                                <ul type="none">
                                                {serviceName.map((ser, i) => {
                                                    return (
                                                    ser.booking_type === 'Domestic' && ser.product_type === 'Document' && (
                                                        <li key={i}>{ser.services_name}</li>
                                                    )
                                                    );
                                                })}
                                                </ul>
                                            </td>
                                            <td>
                                                <ul type="none">
                                                {serviceName.map((ser, i) => {
                                                    return (
                                                    ser.booking_type === 'Domestic' && ser.product_type === 'Document' && (
                                                        <li key={i}>{ser.unique_id} <CopyToClipboard text={ser.unique_id} onCopy={()=>{toast.success(ser.unique_id+' Copied To Clipboard')}}><i className="bx bx-copy"></i></CopyToClipboard></li>
                                                    )
                                                    );
                                                })}
                                                </ul>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="card" >
                                <div className="card-body">
                                    <h5 className="card-title">Available Services (International)</h5>
                                    <table className="table table-bordered">
                                        <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Service</th>
                                            <th>Service Code</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Parcel</td>
                                            <td>
                                                <ul type="none">
                                                {serviceName.map((ser, i) => {
                                                    return (
                                                    ser.booking_type === 'International' && ser.product_type === 'Parcel' && (
                                                        <li key={i}>{ser.services_name}</li>
                                                    )
                                                    );
                                                })}
                                                </ul>
                                            </td>
                                            <td>
                                                <ul type="none">
                                                {serviceName.map((ser, i) => {
                                                    return (
                                                    ser.booking_type === 'International' && ser.product_type === 'Parcel' && (
                                                        <li key={i}>{ser.unique_id} <CopyToClipboard text={ser.unique_id} onCopy={()=>{toast.success(ser.unique_id+' Copied To Clipboard')}}><i className="bx bx-copy"></i></CopyToClipboard></li>
                                                    )
                                                    );
                                                })}
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Document</td>
                                            <td>
                                                <ul type="none">
                                                {serviceName.map((ser, i) => {
                                                    return (
                                                    ser.booking_type === 'International' && ser.product_type === 'Document' && (
                                                        <li key={i}>{ser.services_name}</li>
                                                    )
                                                    );
                                                })}
                                                </ul>
                                            </td>
                                            <td>
                                                <ul type="none">
                                                {serviceName.map((ser, i) => {
                                                    return (
                                                    ser.booking_type === 'International' && ser.product_type === 'Document' && (
                                                        <li key={i}>{ser.unique_id} <CopyToClipboard text={ser.unique_id} onCopy={()=>{toast.success(ser.unique_id+' Copied To Clipboard')}}><i className="bx bx-copy"></i></CopyToClipboard></li>
                                                    )
                                                    );
                                                })}
                                                </ul>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                <div className="card-body">
                    <h6>File Fields</h6>
                    <table className="table table-striped table-bordered table-hover">
                        <tbody><tr>
                        <td title="weight of parcel">(1) Sender unique_id (Customer Id)</td>
                        <td title="Type of Product Ex: Document, Parcel, pallate, Other">(2) Product Type (Product type code) </td>
                        <td title="define mode either COD or Paid">(3) Booking Type (0 for Domestic and 1 for International)</td>
                        </tr>
                        <tr>
                        <td title="sender City">(4) Origin</td>
                        <td title="Receiver City">(5) Destination</td>
                        <td title="total number of piece">(6) Pieces</td>
                        </tr>
                        <tr>
                        <td title="Status Ex: Booked or Picked up etc">(7) Weight</td>
                        <td title="define delivery date when your shipment is reached">(8) Height</td>
                        <td title="Name of sender">(9) Width</td>
                        </tr>
                        <tr>
                        <td title="volumetric weight">(10) Length</td>
                        <td title="Pickup Time (mandatory Time)">(11) Parcel Value</td>
                        <td title="Pickup Date (mandatory Date)">(12) Shipment Status (B)</td>
                        </tr>
                        <tr>
                        <td title="Zipcode of sender">(13) Receiver Name</td>
                        <td title="Mobile of sender">(14) Receiver Address</td>
                        <td title="Mobile of sender">(15) Receiver City</td>
                        </tr>
                        <tr>
                            <td title="Mobile of sender">(16) Receiver State</td>
                            <td title="Mobile of sender">(17) Receiver Country</td>
                            <td title="Email of sender">(18) Receiver Zip</td>
                        </tr>
                        <tr>
                        <td title="Address of sender">(19) Receiver Mobile</td>
                        <td title="Zipcode of Receiver">(20) Receiver Email</td>
                        <td title="Address of Receiver">(21) Sender Name</td>
                        </tr>
                        <tr>
                        <td title="Address of Receiver">(22) Sender Address</td>
                        <td title="Email of sender">(23) Sender City</td>
                        <td title="Mobile of sender">(24) Sender State</td>
                        </tr>
                        <tr>
                        <td title="Mobile of sender">(25) Sender Country</td>
                        <td title="Address of Receiver">(26) Sender Zip</td>
                        <td title="Address of Receiver">(27) Sender Mobile</td>
                        </tr>
                        <tr>
                        <td title="Address of Receiver">(28) Sender Email</td>
                        <td title="Address of Receiver">(29) Service Code</td>
                        <td title="Address of Receiver">(30) COD Amount</td>
                        </tr>
                        <tr>
                        <td title="Address of Receiver">(31) COD Charge (Y, N)</td>
                        <td title="Address of Receiver">(32) Insurance Charge (Y, N)</td>
                        <td title="Address of Receiver">(33) Custom Cleareance (Y, N)</td>
                        </tr>
                        </tbody></table>
                </div>
                </div>
                </>
            }
                <Footer/>
            </main>
        </>
    )
}
export default Bulkshipmentimport;